import { webapi } from '@spot-fe/utils';
import { fetchWithCache } from './storeKit';
import { ConstantCacheKeys } from './constant_cache_keys';
import { AxiosRequestConfig } from 'axios';

export enum HotLabel {
  isHot = 2,
  isNormal = 1,
}

export const scoreTradeNoticeKey = 'spot_preMarketIsScoreTradeNoticePopup';
export const coinNoticeKey = 'spot_preMarketCoinNoticeVersion';

export const btnTypeObject = {
  MakerOrder: 'MakerOrder',
  takerOrderBuy: 'TakerOrderBuy',
  takerOrderSell: 'TakerOrderSell',
}
export interface noticeResult {
  id?: number
  tokenIdLong?: number
  popType?: number
  version?: number
  contentList?: ContentList[]
  updatedAt?: number
  createdAt?: number
}
export interface ContentList {
  language: string
  content: string
  linkName: string
  linkUrl: string
}
export interface Token {
  tokenName: string;
  tokenFullName: string;
  tokenIcon: string;
  settleToken: string;
  tradeBeginTime: number;
  tradeEndTime: number;
  deliveryTime: number;
  pledgeRate: string;
  buyTakerFeeRate: string;
  sellTakerFeeRate: string;
  buyMakerFeeRate: string;
  sellMakerFeeRate: string;
  sortNum: number;
  hotLabel: HotLabel;
  quantityPrecision: string;
  pricePrecision: string;
  minTradeQuantity: string;
  singleMaxTradeAmount: string;
  singleMinTradeAmount: string;
  splitOrders: number
  //0:初始化 1: 可以自动撤单 2:可以交割 3: 交割完成  4:交割中 5:撤单中 6：撤单完成 7:暂停交易
  tokenStatus: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;
  priceScale: number;
  quantityScale: number;
  penaltyRate: string;
  orderNumLimit: string;
  // 1:允许成交  2:不允许成交
  allowTrade: 1 | 2;
  // 默认展示币种标识
  defaultDisplay: boolean;
  // 1.普通代币 2:积分代币 默认 1
  tokenType: 1 | 2;
  //兑换时间  默认 0
  exchangeTime: string;
  //兑换积分数量。 默认 0
  exchangePointsNum: string;
  //兑换代币数量。 默认 0
  exchangeTokenNum: string;
  //显示盘前标识
  airdropTag: number;
  //盘前跳转id
  airdropId: string;
}

export const getTokenTradeCount = () => {
  return webapi.get<TokenTradeCount>(`/spot/api/marketTrading/v1/token/tokenTradeCount`);
};

export const getTokenList = (tab) => {
  const fn = function () {
    return webapi.get<Token[]>(
      `/spot/api/marketTrading/v2/token/tokenList`,
      { tokenTabType: tab }
    );
  }
  return fetchWithCache(fn, ConstantCacheKeys.TOKEN_LIST + tab);
};

export const getTokenDetail = (tokenName) => {
  const fn = function () {
    return webapi.get<Token>(
      `/spot/api/marketTrading/v2/token/tokenInfo`,
      { tokenName }
    );
  }
  return fetchWithCache(fn, ConstantCacheKeys.TOKEN_INFO + tokenName);
};

export interface DynamicData {
  lastPrice: string;
  highPrice: string;
  lowPrice: string;
  lastTime: number;
  accountPaid: string;
  buyQuantity: string;
  sellQuantity: string;
  toDeliverQuantity: string;
  toDeliverPledgeAmount: string;
  frozenAmount: string;
  pledgeAmount: string;
  buyNotDeliveredAmount: string;
  sellPerformanceQuantity: string;
  failedSellOrder: string;
  failedDeliveryCompensation: string;
  totalAmount: string;
  hoursTurnover: string;
  buyDoneOrderQuantity: string;
  buyFrozenOrderQuantity: string;
  sellDoneOrderQuantity: string;
  sellFrozenOrderQuantity: string;
  buyDeliveredQuantity: string;
  buyNotDeliveredQuantity: string;
  sellDefaultQuantity: string;
  sellDefaultAmount: string;
  quoteChange: string;
}
export interface contentListItem {
  language: string;
  content: string;
  linkName: string;
  linkUrl: string;

}
export interface noticeInfoResult {
  id: number;
  tokenIdLong: number;
  popType: number;
  version: number;
  contentList: contentListItem[]
  updatedAt: number;
  createdAt: number;

}
export interface noticeInfoData {
  ret_code: number;
  ret_msg: string;
  result: noticeInfoResult
}

export interface TokenTradeCount {
  itemsNum: number;
  participantsNum: number;
  totalAmount: string
}

export const getDynamicData = (tokenName: string) => {
  // const fn = function(){
  //   return webapi.get<DynamicData>(
  //     `/spot/api/marketTrading/v2/token/dynamicsData`,
  //     { tokenName }
  //   );
  // }
  // return fetchWithCache(fn, ConstantCacheKeys.TOKEN_DYNAMICS_DATA + tokenName);
  return webapi.get<DynamicData>(
    `/spot/api/marketTrading/v2/token/dynamicsData`,
    { tokenName }
  );
};

export const getNoticeInfo = (tokenName: string) => {
  return webapi.get<noticeInfoData>(
    `/spot/api/marketTrading/v1/token/noticeInfo`,
    { tokenName }
  );
};

export enum TradeOrderDirection {
  Prev = 1,
  Next = 2,
}

export enum TradeOrderType {
  Sell = 1,
  Buy = 2,
  Filled = 3,
  OrderBook = 4,
}

export enum ShowMyOrder {
  False = 0,
  True = 1,
}

export enum MatchUserAsset {
  False = 0,
  True = 1,
}

export interface TradeOrderParams {
  direction: TradeOrderDirection;
  // todo long
  fromId: number;
  pageSize: number;
  tokenName: string;
  minAmount: string;
  maxAmount: string;
  minPrice: string;
  maxPrice: string;
  orderType: TradeOrderType;
  showMyOrder: ShowMyOrder;
  matchUserAsset: MatchUserAsset;
  judgeSlice?: boolean
}

export interface TradeOrder {
  orderId: number;
  accountName: string;
  price: string;
  quantity: string;
  orderAmount: string;
  feeAmount: string;
  pledgeAmount: string;
  tradeTime: number;
  isSelf: boolean;
  partType: 0 | 1;
  unfilledPartQuantity:number
  sideType: 1 | 2;
  index: number;
}

export const getTradeOrders = (params: TradeOrderParams) => {
  // const fn = function(){
  //   return webapi.get<TradeOrder[]>(
  //     `/spot/api/marketTrading/v1/order/tradeOrders`,
  //     params
  //   );
  // }
  // return fetchWithCache(fn, ConstantCacheKeys.TRADE_ORDERS + params.tokenName + params.orderType);
  return webapi.get<TradeOrder[]>(
    `/spot/api/marketTrading/v1/order/tradeOrders`,
    params
  );
};

export const getHandicapTradeOrders = (params: TradeOrderParams) => {
  return webapi.get<TradeOrder[]>(
    `/spot/api/marketTrading/v1/order/handicapTradeOrders`,
    {
      ...params,
      orderType: TradeOrderType.Sell,
    }
  );
};

export enum Side {
  Sell = 1,
  Buy = 2,
  All = 0,
}

export interface OrderParams {
  direction: TradeOrderDirection;
  // todo long 改成 string ？
  fromId: number;
  pageSize: number;
  tokenName: string;

  side: Side;
  orderStatus: OrderStatus;
  orderType: OrderType;
}

export enum OrderStatus {
  All = 0,
  UnSettled = 1,
  Settled = 3,
  Delivered = 5,
  Canceled = 7,
  UnDelivered = 8,
  Fail = 9,
  PartiallySold = 12,
  PartiallySold14 = 14,
  PartialDelivery = 15
}

export enum OrderType {
  Current = 1,
  History = 2,
}

export enum TradeType {
  Maker = 1,
  Taker = 2,
}

export interface CurrentOrder {
  orderId: number;
  orderNo: number;
  tokenName: string;
  // orderPrice: string;
  side: TradeOrderType;
  tradeType: TradeType;
  orderPrice: string;

  quantity: number;
  orderTotalAmount: string;
  feeAmount: string;
  pledgeAmount: string;
  orderStatus: OrderStatus;
  // tradeTime: number;
  createOrderTime: number;
  deliveryTime: number;
  // 默认为0 1:用户撤单 2:系统撤单 3:管理后台一键取消
  cancelType: 0 | 1 | 2 | 3;
}

export const getCurrentOrders = (params: OrderParams) => {
  return webapi.get<TradeOrder[]>(
    `/spot/api/marketTrading/v2/order/orderList`,
    params
  );
};

export interface DeliveryTime {
  tokenId: string;
  deliveryTime: number;
}

export const getDeliveryTimes = () => {
  return webapi.get<DeliveryTime[]>(
    `/spot/api/marketTrading/v1/token/deliveryTimes`
  );
};

export interface OrderCount {
  orderNum: number;
}

export const getOrderCount = () => {
  return webapi.get<OrderCount>(`/spot/api/marketTrading/v1/order/countOrder`);
};

export interface CoinIntro {
  publishTime: number;
  publishTotal: string;
  officialWebsite: string;
  whitePaper: string;
  currencyDesc: string;
}

export const getCurrencyIntro = (tokenName: string) => {
  return webapi.get<OrderCount>(
    `/spot/api/marketTrading/v1/token/introduction`,
    { tokenName }
  );
};

export const getTokenNames = () => {
  return webapi.get<OrderCount>(`/spot/api/marketTrading/v1/token/tokenNames`);
};

export enum AccountType {
  ACCOUNT_TYPE_CONTRACT = 'ACCOUNT_TYPE_CONTRACT',
  ACCOUNT_TYPE_SPOT = 'ACCOUNT_TYPE_SPOT',
  ACCOUNT_TYPE_INVESTMENT = 'ACCOUNT_TYPE_INVESTMENT',
  ACCOUNT_TYPE_OPTION = 'ACCOUNT_TYPE_OPTION',
  ACCOUNT_TYPE_UNIFIED = 'ACCOUNT_TYPE_UNIFIED',
  ACCOUNT_TYPE_FUND = 'ACCOUNT_TYPE_FUND',
}

export interface CoinBalanceParams {
  memberId?: string;
  accountType?: AccountType;
  sCoin?: string;
  withBonus?: string;
  toAccountType?: string;
}

export interface Balance {
  bonus: string;
  sCoin: string;
  transferBalance: string;
  walletBalance: string;
}

export interface CoinBalance {
  accountId: number;
  accountType: AccountType;
  bizType: string;
  hasFrozen: boolean;
  memberId: number;
  balance: Balance;
}

// https://bdot.yijin.io/test-ability/test-tools/interface-manage/overView/project/71942fec-130d-419e-8c84-ea22948f7dbe?apiId=10366
export const getCoinBalance = (params: CoinBalanceParams) => {
  // /v3/private/asset/account/coin-balance
  return webapi.get<CoinBalance>(
    `/v3/private/asset/account/coin-balance`,
    params
  );
};

export interface ChartDataParams {
  tokenName: string;
  timeType: enumTimeType;
}

export enum enumTimeType {
  "1D" = 1,
  "7D" = 2,
  "14D" = 3
}

export interface ChartData {
  averageTradePrice: string;
  doneOrderQuantity: string;
  time: enumTimeType
}

export const getChartData = (params:ChartDataParams,config:AxiosRequestConfig) => {
  return webapi.get<ChartData[]>(`/spot/api/marketTrading/v2/order/tradeChartInfo`,params,config);
}


export interface PartOrderConfig {
  partOrderMinTradeQuantity:string
}

// 查询部分成交最小成交数量
export const getPartOrderConfig = (makerOrderId: number) => {
  return webapi.get<PartOrderConfig>(`/spot/api/marketTrading/v1/order/partOrderConfig`,{makerOrderId});
}